
import { defineComponent, ref, computed, onMounted, watch, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useDicomStore } from '@/store/dicom'
import { usePacsStore } from '@/store/pacs';
import lodash from 'lodash';

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const router = useRouter();
    const popupStore = usePopupStore();
    const pacsConfigInfo = computed(() => usePacsStore().getPacsConfigInfo);
    const inputData = ref({
      title: '',
      ip: '',
      port: ''
    })
    const connectState = computed(() => usePacsStore().getConnectState);

    const closePopup = () => {
      popupStore.togglePopup('pacsSetting', false);
    }

    const handleConnectClick = () => {
      usePacsStore().setPacsConfigInfo(inputData.value);
      closePopup();
      popupStore.togglePopup('nowConnect', true);
    }

    const setConnectState = () => {
      usePacsStore().setConnectState(true);
    }

    onMounted(() => {
      inputData.value = lodash.cloneDeep(pacsConfigInfo.value);
    });

    return {
      closePopup,
      handleConnectClick,
      pacsConfigInfo,
      inputData,
      connectState,
      setConnectState
    };
  },
});
